import React from 'react';

import styled from '@emotion/styled';

type Props = {
  active?: boolean;
  title: string;
  description: string;
  icon: React.ReactNode;
  activeIcon?: React.ReactNode;
  handleChange: () => void;
};

export const OfferRequirementsV2: React.FC<Props> = ({
  active,
  title,
  description,
  icon,
  activeIcon,
  handleChange,
}) => {
  return (
    <RequirementContainer active={active} onClick={handleChange}>
      {active ? activeIcon : icon}
      <RequirementInfoContainer>
        <RequirementTitle active={active}>{title}</RequirementTitle>
        <RequirementDescription>{description}</RequirementDescription>
      </RequirementInfoContainer>
    </RequirementContainer>
  );
};

const RequirementContainer = styled.div<{ active?: boolean }>`
  display: flex;
  align-items: center;
  padding: 16px 20px;

  gap: 32px;
  border-radius: 10px;
  border: ${(props) => (props.active ? '2px solid #111' : '1px solid #e6e6e6')};
  cursor: pointer;
`;

const RequirementInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const RequirementTitle = styled.p<{ active?: boolean }>`
  font-size: 15px;
  font-weight: ${(props) => (props.active ? '600' : '400')};
  font-family: Poppins;
  color: #111;
  margin: 0;
  padding: 0;
`;

const RequirementDescription = styled.p`
  color: #848484;
  font-family: Poppins;
  font-size: 13px;
  margin: 0;
  padding: 0;
`;
